interface IAppConst {
    headerHeight: number;
    schoolName: string;
    appicationName: string;
    appicationVersion: string;
    authDescription: string;
    authName: string;
    baseApiURL: string;
    OIDC_AUTHORITY: string;
    OIDC_CLIENT_ID: string;
    OIDC_REDIRECT_URI: string;
    OIDC_CLIENT_SECRET: string;
    OIDC_SCOPE: string;
    OIDC_LOGOUT: string;
    URL_BASE: string;
}
export const appConst: IAppConst = {
    headerHeight: 80,
    schoolName: 'TRƯỜNG ĐẠI HỌC KIẾN TRÚC HÀ NỘI',
    appicationName: 'PHẦN MỀM QUẢN LÝ BỔ SUNG KIẾN THỨC',
    authName: 'ĐẠI HỌC SỐ ESSOFT',
    authDescription: 'PHẦN MỀM QUẢN LÝ',
    appicationVersion: '1.0.0',
    baseApiURL: process.env.REACT_APP_API_BASE_URL?.toString() ?? '',
    OIDC_AUTHORITY: process.env.REACT_APP_OIDC_AUTHORITY?.toString() ?? '',
    OIDC_CLIENT_ID: process.env.REACT_APP_OIDC_CLIENT_ID?.toString() ?? '',
    OIDC_CLIENT_SECRET: process.env.REACT_APP_OIDC_CLIENT_SECRET?.toString() ?? '',
    OIDC_REDIRECT_URI: process.env.REACT_APP_OIDC_REDIRECT_URI?.toString() ?? '',
    OIDC_SCOPE: process.env.REACT_APP_OIDC_SCOPE?.toString() ?? '',
    OIDC_LOGOUT: process.env.REACT_APP_OIDC_LOGOUT?.toString() ?? '',
    URL_BASE: process.env.REACT_APP_URL_BASE?.toString() ?? 'https://localhost:44318/'
};
